import React from 'react';
import useQuantWorker from '../hooks/useQuantWorker';

const STATUS_DISPLAY = {
  idle:           { label: 'Idle', dot: 'bg-gray-400',         text: 'text-gray-500 dark:text-gray-400' },
  pending:        { label: 'Spinning up', dot: 'bg-amber-400 animate-pulse', text: 'text-amber-600 dark:text-amber-400' },
  running:        { label: 'Running',     dot: 'bg-emerald-400 animate-pulse', text: 'text-emerald-600 dark:text-emerald-400' },
  'shutting-down':{ label: 'Shutting down', dot: 'bg-amber-400', text: 'text-amber-600 dark:text-amber-400' },
  unknown:        { label: 'Unknown', dot: 'bg-red-400', text: 'text-red-500 dark:text-red-400' },
  not_configured: { label: 'Not configured', dot: 'bg-gray-300', text: 'text-gray-400' },
};

const WorkerStatusPill = () => {
  const { status, instanceId } = useQuantWorker(5000);
  const display = STATUS_DISPLAY[status] || STATUS_DISPLAY.unknown;
  return (
    <div className="flex items-center gap-2 px-2.5 py-1 rounded-full bg-gray-100 dark:bg-gray-900 text-xs"
         title={instanceId ? `Spot worker: ${instanceId}` : 'No spot worker running'}>
      <span className={`w-2 h-2 rounded-full ${display.dot}`}></span>
      <span className={`uppercase tracking-wider ${display.text}`}>{display.label}</span>
      {instanceId && (
        <span className="text-gray-400 dark:text-gray-500 font-mono text-[10px] hidden sm:inline">
          {instanceId.slice(-8)}
        </span>
      )}
    </div>
  );
};

export default WorkerStatusPill;
